import * as apiClient from '../../services/api-client';
import getSymbolFromCurrency from 'currency-symbol-map'

export const getMe = async (store, token) => {
    const user = await apiClient.user.getMe(token);
    const auth = {
        cla_token: token,
        cla_uid: user.id
    }
    console.log('GOT ME...SETTING AUTH', auth);
    store.setState({ auth });
};

export const getUserById = async (store, userId) => {
    const res = await apiClient.user.getUser(userId, store.state.auth.cla_token);
    const user = res[0];
    if(userId === store.state.auth.cla_uid) {
        store.setState({ user });
        return;
    }
    let activeGiftlist = {
        ...store.state.activeGiftlist,
        user: user
    };
    store.setState({ activeGiftlist });
};

export const updateUserProfile = async (store, userData) => {
    const responseData = await apiClient.user.updateUserProfile(userData, store.state.auth.cla_token);
    let responseType = "updateprofile";
    if(userData.userID === store.state.user.userID) {
        store.setState({ 
            ...store.state,
            user: {
                ...store.state.user,
                ...responseData
            }
        });
    } else {
        responseType = "updategiftlist";
        store.setState({ 
            ...store.state,
            activeGiftlist: {
                ...store.state.activeGiftlist,
                user: {
                    ...store.state.activeGiftlist.user,
                    ...responseData
                }
            }
        });
    }

    const response = {
        type: responseType,
        data: responseData
    };
    store.setState({ response });
};

export const getUserShoppinglist = async (store, userId) => {
    const shoppinglist = await apiClient.user.getShoppinglist(userId, store.state.auth.cla_token);
    store.setState({ shoppinglist });
};

export const getUserGiftlists = async (store, userId) => {
    const giftlists = await apiClient.giftlist.getUserNicelist(userId, store.state.auth.cla_token);
    store.setState({ giftlists });
};

export const getUserGiftlist = async (store, userId) => {
    if(userId === store.state.auth.cla_uid) {
        const mygiftlist = await apiClient.giftlist.getUserGiftlist(userId, store.state.auth.cla_token);
        store.setState({ mygiftlist });
        return;
    }
    const giftlist = await apiClient.giftlist.getUserGiftlist(userId, store.state.auth.cla_token);
    let activeGiftlist = {
        ...store.state.activeGiftlist,
        giftlist: giftlist
    };
    store.setState({ activeGiftlist });
};

export const getUserSuggested = async (store, userId=null) => {
    if(!userId) {
        userId = store.state.auth.cla_uid;
    }
    const suggesteds = await apiClient.giftlist.getUserSuggested(userId, store.state.auth.cla_token);
    store.setState({ suggesteds });
};

export const getUserArchive = async (store, userId) => {
    if(userId === store.state.auth.cla_uid) {
        const myarchive = await apiClient.user.getUserArchive(userId, store.state.auth.cla_token);
        store.setState({ myarchive });
        return;
    }
    const archive = await apiClient.user.getUserArchive(userId, store.state.auth.cla_token);
    let activeGiftlist = {
        ...store.state.activeGiftlist,
        archive: archive
    };
    store.setState({ activeGiftlist });
};

export const addGiftlist = async (store, listData) => {
    let responseData = await apiClient.nicelist.addGiftlist(listData, store.state.auth.cla_token);
    responseData.addedBy = {
        userID: store.state.user.userID,
        FirstName: store.state.user.FirstName,
        LastName: store.state.user.LastName
    };
    const response = {
        type: "addgiftlist",
        data: responseData
    };
    store.setState({ response });

    //add to giftlists
    const giftlists = [
        ...store.state.giftlists,
        responseData
    ];
    store.setState({ giftlists });

    //remove from suggesteds (if found there)
    let idx = store.state.suggesteds.map(sl => sl.userID).indexOf(listData.userID);
    if(idx < 0) {
        return;
    }
    let suggesteds = [
        ...store.state.suggesteds.slice(0, idx),
        ...store.state.suggesteds.slice(idx+1)
    ];
    store.setState({ suggesteds });
};

export const updateBudget = async (store, budgetData) => {
    //'connectionID'=>0, 'userID'=>0, 'budget'=>0
    const responseData = await apiClient.nicelist.updateBudget(budgetData, store.state.auth.cla_token);
    const response = {
        type: "updatebudget",
        data: responseData
    };
    store.setState({ response });

    //update giftlist
    let idx = store.state.giftlists.map(gl => gl.connectionID).indexOf(budgetData.connectionID);
    let conn = store.state.giftlists[idx];
    conn.budget = budgetData.budget;
    const giftlists = [
        ...store.state.giftlists.slice(0, idx),
        conn,
        ...store.state.giftlists.slice(idx+1)
    ];
    store.setState({ giftlists });

};

export const removeGiftlist = async (store, userID) => {
    const responseData = await apiClient.nicelist.removeGiftlist(userID, store.state.auth.cla_token);
    const response = {
        type: "deletegiftlist",
        data: responseData
    };
    store.setState({ response });

    //remove from giftlists
    let idx = store.state.giftlists.map(gl => gl.userID).indexOf(userID);
    const giftlists = [
        ...store.state.giftlists.slice(0, idx),
        ...store.state.giftlists.slice(idx+1)
    ];
    store.setState({ giftlists });

}

export const getUserActivityFeed = async (store, userID, pg=1) => {
    const responseData = await apiClient.user.getActivityFeed(userID, pg, store.state.auth.cla_token);
    if(pg === 1) {
        const activity = responseData;
        store.setState({ activity });
    } else {
        const activity = [
            ...store.state.activity,
            ...responseData
        ];
        store.setState({ activity });
    }
    
}

export const searchByEmail = async (store, email) => {
    const responseData = await apiClient.user.findByEmail(email, store.state.auth.cla_token);
    const response = {
        type: "searchbyemail",
        data: responseData
    };
    store.setState({ response });
}

export const createSharelink = async (store, linkData) => {
    linkData.uid = store.state.auth.cla_uid;
    const responseData = await apiClient.user.createShareLink(linkData, store.state.auth.cla_token);
    const response = {
        type: "createsharelink",
        data: responseData
    };
    store.setState({ response });
}

export const emailSharelink = async (store, linkData) => {
    linkData.uid = store.state.auth.cla_uid;
    const responseData = await apiClient.user.createShareLink(linkData, store.state.auth.cla_token);
    const response = {
        type: "emailsent",
        data: responseData
    };
    store.setState({ response });
}

export const uploadAvatar = async (store, formData, userID) => {
    console.log('BEGINNING UPLOAD', formData);
    const responseData = await apiClient.user.uploadAvatar(formData, userID, store.state.auth.cla_token);
    const response = {
        type: "avatarupload",
        data: responseData
    };
    store.setState({ response });
}

export const getUserCurrencySymbol = (store) => {
    return store.state.user ? getSymbolFromCurrency(store.state.user.currency) : '$';
}
